module.exports = __webpack_public_path__ + "static/media/upload.857f36bc.svg";